// 11/29 關閉fetch_setLeaderInfo 改api模式讀取kol個人頁 捨棄localforage
export const LEADERINFO = 'LEADERINFO';
export const LEADERINFO_ERROR = 'LEADERINFO_ERROR';
export const LEADERINFO_ISLOADING = 'LEADERINFO_ISLOADING';
import localforage from 'localforage';

export function fetch_setLeaderInfo(chipsData, cateChipsData, fansMin, fansMax, dayQuery, period, leaderInfo, sourceValue){
  const submitInfo = {
    chipsData: chipsData === undefined ? []: chipsData,
    cateChipsData: cateChipsData === undefined ? []: cateChipsData,
    fansMin: fansMin === undefined ? 0.1 : fansMin,
    fansMax: fansMax === undefined ? 3000 : fansMax,
    dayQuery: dayQuery === undefined ? 30 : dayQuery,
    period: period === undefined ? 1 : period,
    leaderInfo: leaderInfo === undefined ? null : leaderInfo,
    sourceValue: sourceValue === undefined ? {fbClass:'FB', ytClass:'YT', igClass:'IG'} : sourceValue,
  }
  return (dispatch) =>{
    dispatch(leaderInfo_isloading(true))
    localforage.setItem('dashLeaderValue',submitInfo).then(function(value) {
        dispatch(leaderInfo_success(value))
        dispatch(leaderInfo_isloading(false))
    }).catch(function(err) {
        console.log(err)
        dispatch(leaderInfo_isloading(false))
        return dispatch(leaderInfo_error(true))
    })
  }

}

export function fetch_getLeaderInfo(){

  return (dispatch) =>{
    dispatch(leaderInfo_isloading(true))
    localforage.getItem('dashLeaderValue').then(function(value) {
        if(value){
          dispatch(leaderInfo_success(value))
        }
        dispatch(leaderInfo_isloading(false))
    }).catch(function(err) {
        console.log(err)
        dispatch(leaderInfo_isloading(false))
        return dispatch(leaderInfo_error(true))
    })
  }

}

export function leaderInfo_isloading(bool){
  return {
    type:LEADERINFO_ISLOADING,
    isLoading: bool
  }
}

export function leaderInfo_success(response){
  return {
    type:LEADERINFO,
    payload: response
  }
}

export function leaderInfo_error(bool){
  return {
    type:LEADERINFO_ERROR,
    hasErrored:bool,
  }
}




// WEBPACK FOOTER //
// ./src/actions/fetch_leaderinfo.js